import { render, staticRenderFns } from "./Receipts.vue?vue&type=template&id=57cb41b4"
import script from "./Receipts.vue?vue&type=script&lang=js"
export * from "./Receipts.vue?vue&type=script&lang=js"
import style0 from "./Receipts.vue?vue&type=style&index=0&id=57cb41b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports